export default __webpack_public_path__ + "static/report-date-filtered-395db56afe5211c6a171b7c33a4cc05c.mp4";